<script setup>
  const props = defineProps(['src', 'options', 'options-hover']);

  const svgHtmlEl = ref(null);
  const isHover = ref(false);

  function updateUI() {
    if (!svgHtmlEl.value) return;

    const svg = svgHtmlEl.value.querySelector('svg');

    if (!svg) return;

    svg.style.width = '100%';
    svg.style.height = '100%';

    if (props.options?.color) svg.style.fill = 'currentColor';
    if (props.options?.stroke) svg.style.stroke = props.options.stroke;

    var paths = svg.querySelectorAll('path');

    Array.from(paths).map(path => {
      // Устанавливаем fill только если не указан stroke (для fill-based иконок)
      if (!props.options?.stroke){// && props.options?.color) {
        path.style.fill = 'currentColor';
      } else {
        // Для stroke-based иконок убираем fill
        path.style.fill = 'none';
        path.style.stroke = props.options?.stroke || 'none';
        if (props.options?.strokeWidth) path.style.strokeWidth = props.options.strokeWidth;
      }
    });
  }

  async function loadSvg() {
    const svg = await loadFile(props.src);
    if (svgHtmlEl.value) svgHtmlEl.value.innerHTML = svg;
  }

  function watchProps() {
    watch(
      () => props.src,
      async () => {
        await loadSvg();
        updateUI();
      },
      {
        immediate: true
      }
    );
    watch(
      () => [props.src, svgHtmlEl.value, props.options],
      () => {
        updateUI();
      }
    );
  }

  onMounted(() => {
    watchProps();
  });
</script>
<template>
  <div
    class="svg-el"
    :style="{
      color: props.options?.color || 'var(--base-icons-color)',
      width: props.options?.width || props.options?.size,
      height: props.options?.height || props.options?.size
    }"
  >
    <div :ref="el => (svgHtmlEl = el)" class="svg-content"></div>
  </div>
</template>
<style scoped>
    .svg-el {
        display: block;
        max-width: 30px;
        min-width: 20px;
    }
    .svg-content {
        display: contents;
    }
</style>
